import type {
  Block,
  ParagraphData,
  TextPart,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";
import "./paragraph.css"

export default function ParagraphView({ block }: { block: Block }) {
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-paragraph">
      {(data.textParts || []).map((part, i) => {
        if (part.type === "text") {
          return <span key={i}>{part.value}</span>;
        }

        return (
          <RefLink
            key={i}
            targetId={part.targetId}
            label={part.label}
            className="pdf-ref-link text-primary"
          />
        );
      })}
    </div>
  );
}
